import { render, staticRenderFns } from "./inboxsidebar.vue?vue&type=template&id=695d7be4"
import script from "./inboxsidebar.vue?vue&type=script&lang=js"
export * from "./inboxsidebar.vue?vue&type=script&lang=js"
import style0 from "./inboxsidebar.vue?vue&type=style&index=0&id=695d7be4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports